import { faCog, faCogs, faFileImport, faList } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import { useRouteMatch } from "react-router-dom";
import { Logo } from "../Logo";
import { MainLayout } from "../org/MainLayout";
import DataLayout from "./DataLayout";

const Data = (props:any) => {
    const { url } = useRouteMatch();

    const navigation = [
        { name: 'Catalogs', to: `${url}/settings`, icon: faCogs },
        { name: 'Properties', to: `${url}/properties`, icon: faList },
        { name: 'Import', to: `${url}/import`, icon: faFileImport },
    ];
    return (
        <MainLayout {...props} navigation={navigation} logo={<Logo {...props} />}>
            <DataLayout {...props}/>
        </MainLayout>
    );
}

export default Data;